import { Component } from '@angular/core';
import { NbMenuService } from '@nebular/theme';
@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  footertitle;
  constructor(
    private menuService: NbMenuService,
    ) {
      var userconfig = JSON.parse(localStorage.getItem('userconfig'));
      if(userconfig)
      {
      if(userconfig.AppModuleType==1)
        {
          //this.footertitle = "HỆ THỐNG QUẢN LÝ THỜI GIAN HỌC LÝ THUYẾT MÔN PHÁP LUẬT GTĐB";
        }
        else if(userconfig.AppModuleType==2)
        {
         // this.footertitle = "GIÁM SÁT THỜI GIAN VÀ QUÃNG ĐƯỜNG HỌC THỰC HÀNH LÁI XE Ô TÔ";
        }
        else if (userconfig.AppModuleType==3)
        {
          //this.footertitle = "GIÁM SÁT THỜI GIAN VÀ QUÃNG ĐƯỜNG HỌC THỰC HÀNH LÁI XE Ô TÔ";
        }      
      }
      else
      {
        //this.footertitle = "HỆ THỐNG QUẢN LÝ THỜI GIAN HỌC LÝ THUYẾT MÔN PHÁP LUẬT GTĐB";
      }
}
  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }
}
